import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "search",
    "count",
    "chips",
    "list",
    "option",
    "checkbox",
    "clear",
    "noResults",
  ];

  connect() {
    this.render();
  }

  filter() {
    const query = this.hasSearchTarget
      ? this.searchTarget.value.trim().toLowerCase()
      : "";

    let visibleCount = 0;

    this.optionTargets.forEach((option) => {
      const haystack = option.dataset.staffSearch || "";
      const matches = query === "" || haystack.includes(query);
      option.classList.toggle("d-none", !matches);
      if (matches) visibleCount += 1;
    });

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("d-none", visibleCount > 0);
    }
  }

  toggle(event) {
    const option = event.target.closest(".rb-staff-option");
    if (option) {
      option.classList.toggle("is-selected", event.target.checked);
    }
    this.render();
  }

  clearAll() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
      const option = checkbox.closest(".rb-staff-option");
      if (option) option.classList.remove("is-selected");
    });
    this.render();
  }

  removeChip(event) {
    const { staffId } = event.currentTarget.dataset;
    const checkbox = this.checkboxTargets.find((box) => box.value === staffId);
    if (!checkbox) return;

    checkbox.checked = false;
    const option = checkbox.closest(".rb-staff-option");
    if (option) option.classList.remove("is-selected");
    this.render();
  }

  render() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked);

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${selected.length} selected`;
    }

    if (this.hasClearTarget) {
      this.clearTarget.classList.toggle("d-none", selected.length === 0);
    }

    if (!this.hasChipsTarget) return;

    this.chipsTarget.innerHTML = "";

    selected.forEach((checkbox) => {
      const chip = document.createElement("span");
      chip.className = "rb-chip";

      const label = document.createElement("span");
      label.textContent = checkbox.dataset.staffName || "Staff member";
      chip.appendChild(label);

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "rb-chip__remove";
      remove.innerHTML = "&times;";
      remove.setAttribute(
        "aria-label",
        `Remove ${checkbox.dataset.staffName || "staff member"}`
      );
      remove.dataset.staffId = checkbox.value;
      remove.dataset.action = "room-booking-staff-picker#removeChip";
      chip.appendChild(remove);

      this.chipsTarget.appendChild(chip);
    });
  }
}
